import React from 'react';

import '../../styles/Guide.css';


class APIDemo extends React.Component {

  render() {
    return (
      <div className="channel-test-wapper">
          <img src={require('../../img/guide/channel/mockup_phone.svg')} alt="phone-mockup" className="channel-test-mockup-phone"/>
          <div className="channel-test-demo-wapper">
            <iframe src="https://demo.mojitok.com/demo" title="fb-extension" scrolling="auto" className= "channel-test-demo"/>
          </div>
      </div>
    )
  }
}


export default APIDemo;
